
import axios from 'axios';


export async function getCnpj(cnpj) {
  const data = await axios.get(`https://api-publica.speedio.com.br/buscarcnpj?cnpj=${cnpj}`)

  return data;
}
